// extracted by mini-css-extract-plugin
var _1 = "DropdownMenu-module__animateUploadProgressBarWidth--Danip";
var _2 = "DropdownMenu-module__animatedBackground--niJZ7";
var _3 = "DropdownMenu-module__dropdown--HOOax";
var _4 = "DropdownMenu-module__emptyMessage--FJBDK";
var _5 = "DropdownMenu-module__focused--PSllO";
var _6 = "DropdownMenu-module__hotkeyInfoContainer--bc_Po";
var _7 = "DropdownMenu-module__item--ckk2m";
var _8 = "DropdownMenu-module__sectionHeader--PC_kj";
var _9 = "DropdownMenu-module__sectionHeaderLabel--r8EET";
var _a = "DropdownMenu-module__sectionWrapper--MBY9Z";
var _b = "DropdownMenu-module__withPadding--tRmA9";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "dropdown", _4 as "emptyMessage", _5 as "focused", _6 as "hotkeyInfoContainer", _7 as "item", _8 as "sectionHeader", _9 as "sectionHeaderLabel", _a as "sectionWrapper", _b as "withPadding" }
